export const PRICING_PLANS = [
  {
    key: 'starter',
    id: 'starter',
    name: 'Starter',
    monthly: 149,
    yearly: 1490,
    users: '1 utilisateur',
    usersLimit: 1,
    storageLimitGb: 5,
    warehouses: '1 dépôt pour votre stock principal',
    icon: 'bi bi-receipt-cutoff',
    audience: 'Indépendants & TPE',
    description: 'Pour démarrer avec clients, factures et stock simple.',
    button: 'Commencer',
    keyFeatures: ['Clients et produits', 'Devis, factures et BL', 'Paiements', 'Stock simple avec 1 dépôt'],
    usageLimits: ['1 société', '5 Go de stockage', 'Aide import Excel en self-service'],
    features: ['Clients', 'Produits', 'Quotes / devis', 'Invoices / factures', 'Delivery notes / bons de livraison', 'Payments', 'Stock simple avec 1 dépôt', 'Rapports de base'],
    exclusions: ['POS', 'Import IA', 'Projets', 'Abonnements', 'Réservations', 'Rapports avancés', 'Multi-dépôt', 'Support prioritaire'],
    deniedPermissions: ['view_suppliers', 'view_orders', 'view_returns'],
    deniedModuleItems: {
      sales: ['orders', 'returns', 'sales_insights'],
      finance: ['zakat']
    },
    moduleKeys: ['dashboard', 'crm', 'inventory', 'sales', 'finance', 'advanced_insights', 'planning']
  },
  {
    key: 'business',
    id: 'business',
    name: 'Business',
    monthly: 249,
    yearly: 2490,
    users: '3 utilisateurs',
    usersLimit: 3,
    storageLimitGb: 20,
    warehouses: '3 dépôts: magasin, réserve ou entrepôt',
    icon: 'bi bi-briefcase',
    audience: 'Meilleur choix PME',
    description: 'Pour gérer ventes, achats, stock et fournisseurs.',
    button: 'Essayer maintenant',
    recommended: true,
    keyFeatures: ['Ventes et achats', 'Fournisseurs', 'Stock par magasin, réserve ou entrepôt', 'Rapports, pièces jointes et documents'],
    usageLimits: ['1 société', '20 Go de stockage', 'Utilisateurs sup. sur demande'],
    features: ['Tout Starter', 'Gestion des ventes', 'Gestion des achats', 'Fournisseurs', 'Suivi stock par dépôt', 'Paiements / trésorerie', 'Rapports', 'Pièces jointes', 'Documents clients et fournisseurs', 'Aide import Excel'],
    exclusions: ['POS', 'Import IA', 'Projets', 'Abonnements', 'Réservations', 'Support prioritaire'],
    moduleKeys: ['dashboard', 'crm', 'inventory', 'sales', 'purchases', 'finance', 'attachments', 'accountant', 'advanced_insights', 'leads', 'contracts', 'planning', 'importer']
  },
  {
    key: 'pro',
    id: 'pro',
    name: 'Pro',
    monthly: 499,
    yearly: 4990,
    users: '10 utilisateurs',
    usersLimit: 10,
    storageLimitGb: 50,
    warehouses: 'Dépôts illimités pour plusieurs sites',
    icon: 'bi bi-lightning-charge',
    audience: 'Opérations avancées',
    description: 'Pour POS, multi-dépôt, GStocky AI et modules avancés.',
    button: 'Passer à Pro',
    keyFeatures: ['POS', 'Dépôts illimités pour plusieurs sites', 'Rapports avancés', 'GStocky AI: import factures fournisseurs'],
    usageLimits: ['1 société', '50 Go de stockage', '100 imports IA / mois', '2 caisses POS incluses'],
    features: ['Tout Business', 'POS', 'Transferts et suivi stock multi-site', 'Rapports avancés', 'Projets', 'Abonnements', 'Réservations', 'GStocky AI: import factures fournisseurs', 'Support prioritaire', '2 caisses POS incluses'],
    exclusions: [],
    moduleKeys: ['dashboard', 'crm', 'inventory', 'sales', 'purchases', 'pos', 'finance', 'attachments', 'subscription_management', 'reservations', 'accountant', 'project_management', 'hr', 'advanced_insights', 'contracts', 'planning', 'leads', 'ai', 'importer']
  },
  {
    key: 'enterprise',
    id: 'enterprise',
    name: 'Enterprise',
    users: 'Utilisateurs illimités',
    usersLimit: null,
    storageLimitGb: null,
    warehouses: 'Dépôts illimités et sites personnalisés',
    icon: 'bi bi-building-check',
    audience: 'Sur mesure',
    description: 'Pour besoins avancés, multi-société et intégrations.',
    button: 'Nous contacter',
    enterprise: true,
    keyFeatures: ['Multi-société', 'Marketing', 'Templates personnalisés', 'Onboarding et formation', 'Intégrations spécifiques'],
    usageLimits: ['Utilisateurs selon besoin', 'Stockage personnalisé', 'Caisses POS et imports IA personnalisés'],
    features: ['Multi-société', 'Marketing', 'Modèles de documents personnalisés', 'Onboarding dédié', 'Formation', 'Support prioritaire', 'Intégrations spécifiques', 'Assistance dédiée', 'Migration accompagnée'],
    exclusions: [],
    moduleKeys: ['*']
  }
];

export const DEFAULT_PLAN_KEY = 'business';

export const PLAN_INTENT_STORAGE_KEY = 'gstocky_signup_plan_intent';

export const normalizeBillingInterval = (interval) => {
  return ['monthly', 'yearly'].includes(interval) ? interval : null;
};

export const normalizeDiscountPercent = (discount) => {
  const parsedDiscount = Number(discount);
  if (!Number.isFinite(parsedDiscount) || parsedDiscount <= 0) return 0;
  return Math.min(Math.round(parsedDiscount * 100) / 100, 50);
};

export const OFFER_DISCOUNTS = {
  bni: 20
};

export const normalizeOfferCode = (offer) => {
  return String(offer || '').trim().toLowerCase();
};

export const getOfferDiscountPercent = (offer) => {
  return normalizeDiscountPercent(OFFER_DISCOUNTS[normalizeOfferCode(offer)] || 0);
};

export const applyDiscountToPrice = (price, discount = 0) => {
  const normalizedDiscount = normalizeDiscountPercent(discount);
  return Math.round(Number(price || 0) * (1 - normalizedDiscount / 100));
};

export const normalizePlanIntent = (planKey, interval = 'monthly', discount = 0, offer = '') => {
  const plan = PRICING_PLANS.find(plan => plan.key === planKey || plan.id === planKey);
  const billingCycle = normalizeBillingInterval(interval) || 'monthly';
  const offerCode = normalizeOfferCode(offer);
  const discountPercent = normalizeDiscountPercent(getOfferDiscountPercent(offerCode) || discount);

  if (!plan || plan.enterprise) return null;

  return {
    plan: plan.key,
    interval: billingCycle,
    billing_cycle: billingCycle,
    offer: offerCode || null,
    offer_code: offerCode || null,
    discount: discountPercent,
    discount_percent: discountPercent
  };
};

export const savePlanIntentFromQuery = (query = {}) => {
  const planKey = query.plan;
  const interval = query.interval || query.billing || query.billing_cycle;
  const offer = query.offer;
  const intent = normalizePlanIntent(planKey, interval, 0, offer);

  if (!intent) return null;

  localStorage.setItem(PLAN_INTENT_STORAGE_KEY, JSON.stringify(intent));
  return intent;
};

export const getStoredPlanIntent = () => {
  try {
    const storedIntent = JSON.parse(localStorage.getItem(PLAN_INTENT_STORAGE_KEY) || '{}');
    return normalizePlanIntent(
      storedIntent.plan,
      storedIntent.interval || storedIntent.billing_cycle,
      storedIntent.discount ?? storedIntent.discount_percent,
      storedIntent.offer || storedIntent.offer_code
    );
  } catch (e) {
    return null;
  }
};

export const clearStoredPlanIntent = () => {
  localStorage.removeItem(PLAN_INTENT_STORAGE_KEY);
};

export const PRICING_MARKET_NOTES = [
  'Prix affichés en DH HT',
  'Annulation possible à tout moment'
];

export const PRICING_ADDONS = [
  '+59 DH TTC / utilisateur supplémentaire / mois',
  '+47 DH TTC / dépôt supplémentaire / mois',
  'Volume IA, stockage et caisses POS personnalisables'
];

export const MOROCCO_COUNTRY_CODE = 'MA';
// Catalog prices use the same fixed 10 MAD = 1 USD rate as the existing plan admin UI.
export const MAD_PER_USD = 10;

export const getBrowserPricingCountryCode = () => {
  if (typeof navigator === 'undefined') return null;

  try {
    if (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Africa/Casablanca') {
      return MOROCCO_COUNTRY_CODE;
    }
  } catch (error) {
    // Continue with browser locale detection.
  }

  const locales = [
    ...(Array.isArray(navigator.languages) ? navigator.languages : []),
    navigator.language,
    navigator.userLanguage
  ].filter(Boolean);

  for (const locale of locales) {
    try {
      const region = typeof Intl.Locale === 'function'
        ? new Intl.Locale(locale).region
        : String(locale).split(/[-_]/).slice(1).reverse().find(part => /^[A-Za-z]{2}$/.test(part));
      if (region) return region.toUpperCase();
    } catch (error) {
      // Try the next browser locale.
    }
  }

  return null;
};

export const getPricingCurrency = (countryCode) => {
  const normalizedCountryCode = String(countryCode || '').trim().toUpperCase();
  return normalizedCountryCode && normalizedCountryCode !== MOROCCO_COUNTRY_CODE ? 'USD' : 'MAD';
};

export const convertPlanPrice = (price, currency = 'MAD') => {
  const amount = Number(price || 0);
  if (currency !== 'USD') return amount;
  return Math.round((amount / MAD_PER_USD) * 100) / 100;
};

export const formatPlanAmount = (price, currency = 'MAD') => {
  const convertedPrice = convertPlanPrice(price, currency);
  const locale = currency === 'USD' ? 'en-US' : 'fr-MA';
  return convertedPrice.toLocaleString(locale, {
    minimumFractionDigits: currency === 'USD' && !Number.isInteger(convertedPrice) ? 2 : 0,
    maximumFractionDigits: 2
  });
};

export const getPlanCurrencySymbol = (currency = 'MAD') => currency === 'USD' ? '$' : 'DH';

export const getPricingPlan = (planKey) => {
  return PRICING_PLANS.find(plan => plan.key === planKey || plan.id === planKey) || PRICING_PLANS.find(plan => plan.key === DEFAULT_PLAN_KEY);
};

export const getBusinessPlanKey = (business = {}) => {
  return business?.metadata?.plan_key || business?.metadata?.pricing_plan || business?.plan_id || DEFAULT_PLAN_KEY;
};

export const getBusinessPricingPlan = (business = {}) => {
  return getPricingPlan(getBusinessPlanKey(business));
};

export const canPlanAccessModule = (planKey, moduleKey) => {
  const plan = getPricingPlan(planKey);
  return plan.moduleKeys.includes('*') || plan.moduleKeys.includes(moduleKey);
};

export const permissionViewKey = (permission = '') => {
  const actionMatch = permission.match(/^(create|edit|delete|manage)_(.+)$/);
  if (!actionMatch) return permission;

  const subject = actionMatch[2];
  return subject.startsWith('view_') ? subject : `view_${subject}`;
};

export const canPlanAccessPermission = (planKey, permission) => {
  const plan = getPricingPlan(planKey);
  const deniedPermissions = plan.deniedPermissions || [];
  const normalizedPermission = permissionViewKey(permission);
  return !deniedPermissions.includes(normalizedPermission);
};

export const canPlanAccessModuleItem = (planKey, moduleKey, permission, itemTitle = '') => {
  const plan = getPricingPlan(planKey);
  const deniedItems = plan.deniedModuleItems?.[moduleKey] || [];
  return canPlanAccessModule(planKey, moduleKey) &&
    canPlanAccessPermission(planKey, permission) &&
    !deniedItems.includes(itemTitle);
};

export const formatPlanPrice = (price, currency = 'MAD') => {
  const amount = formatPlanAmount(price, currency);
  return currency === 'USD' ? `$${amount} TTC` : `${amount} DH TTC`;
};
